import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  ResourceDetailsConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ResourceDetailsConfiguration;
  retrieveResourceDetailsConfiguration(
    req: Boundaries["retrieveResourceDetailsConfiguration"]["request"],
  ): void;
}

function useRetrieveResourceDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourceDetailsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourceDetailsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourceDetailsConfigurationRequestFailure(planzone),
    ),
    configuration: useSelector(() =>
      selector.getResourceDetailsConfiguration(planzone),
    ),
    retrieveResourceDetailsConfiguration:
      core.retrieveResourceDetailsConfiguration,
  };
}

export { useRetrieveResourceDetailsConfiguration };
